import type { ChromecastSession, DiceResolvableSourceCustomData } from '@dicetechnology/dice-doris';
import { DICE_RESOLVABLE_SOURCE, Environment, isChromecastSessionV1 } from '@dicetechnology/dice-doris';
import type { BeaconPayloadV1 } from '@dicetechnology/dice-doris/dist/types/dice/types/BeaconPayloadV1';
import { EBeaconAction } from '@dicetechnology/dice-unity/lib/services/Beacon/types';
import type { MediaInformation } from 'chromecast-caf-receiver/cast.framework.messages';

import { getApiBaseUrl } from '../services/DiceReceiverManager/utils';

export const getBeaconPayloadFromChromecastSession = (
    session: ChromecastSession,
    media: MediaInformation,
    currentTime: number = 0
): BeaconPayloadV1 => {
    if (isChromecastSessionV1(session)) {
        return session.beacon;
    } else {
        let isLive: boolean | undefined = undefined;
        let videoId: number | undefined = undefined;

        if (media.customData?.resolutionType === DICE_RESOLVABLE_SOURCE && media.customData?.resolutionCustomData) {
            const resolutionCustomData: DiceResolvableSourceCustomData = media.customData.resolutionCustomData;
            isLive = resolutionCustomData.isLive ?? false;
            videoId = parseInt(media.contentId, 10);
        } else if (session.beacon) {
            isLive = session.beacon.isLive;
            videoId = session.beacon.videoId;
        }

        if (isLive === undefined || videoId === undefined) {
            throw new Error('Beacon information is required when using static sources.');
        }

        // Construct an absolute URL since the `/v1/heartbeat` endpoint does not have a `/api` prefix.
        const baseUrl = new URL(getApiBaseUrl(session.env ?? Environment.PROD));
        const origin = baseUrl.origin;
        const url = `${origin}/v1/heartbeat`;

        return {
            action: isLive ? EBeaconAction.LIVE : EBeaconAction.VOD,
            video: videoId,
            endpoint: url,
            progress: isLive ? undefined : currentTime
        };
    }
};
